import * as React from 'react';
import AppTabs from '../../../components/AppTabs';
import { FC, useState } from 'react';
import { Tab } from '@material-ui/core';
import { Card, CardBody } from 'reactstrap';
import { ReportsSettingsData } from '../../../models';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import ReportsSettings from '../ReportsSettings';
import DocumentsSettings from '../DocumentsSettings';

interface Props {
    id: string;
    reportsSettingsData: ReportsSettingsData;
    onSaveReports: (settings: ReportsSettingsData) => void;
}

const ReportsAndDocumentsSettings: FC<Props> = ({ id, reportsSettingsData, onSaveReports }) => {
    const t = useTranslations();
    const [activeTab, setActiveTab] = useState(0);

    return (
        <>
            <h4 style={{ color: 'var(--text-body)', marginBottom: 'var(--spacer-S)', fontSize: '1.25rem', fontWeight: 600 }}>
                {t(TK.reports)} & {t(TK.documents)}
            </h4>
            <Card style={{ marginBottom: 'var(--spacer-M)' }}>
                <AppTabs
                    value={activeTab}
                    onChange={(_, v) => setActiveTab(v)}
                    style={{ borderBottom: 'var(--border-thin) solid var(--appLigthGrey)' }}
                >
                    <Tab label={t(TK.reports)} />
                    <Tab label={t(TK.documents)} />
                </AppTabs>
                <CardBody>
                    {activeTab === 0 && (
                        <ReportsSettings id={`${id}-reports-content`} />
                    )}
                    {activeTab === 1 && (
                        <DocumentsSettings
                            id={`${id}-documents-content`}
                            values={reportsSettingsData}
                            onChange={(newSettings, save) => { if (save) onSaveReports(newSettings); }}
                        />
                    )}
                </CardBody>
            </Card>
        </>
    );
};

export default ReportsAndDocumentsSettings;
